import type { GeneralSettings } from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

export function fetchTestMode(): Promise<{ enabled: boolean }> {
  return apiFetch('/api/settings/test-mode');
}

export function updateTestMode(enabled: boolean): Promise<{ enabled: boolean }> {
  return apiFetch('/api/settings/test-mode', { method: 'PUT', body: { enabled } });
}

/** Onglet Général (`02` §12.1). */
export function fetchGeneralSettings(): Promise<GeneralSettings> {
  return apiFetch<GeneralSettings>('/api/settings/general');
}

export function updateGeneralSettings(body: GeneralSettings): Promise<GeneralSettings> {
  return apiFetch<GeneralSettings>('/api/settings/general', { method: 'PUT', body });
}
